import React from "react";
import { useT } from "../context/LanguageContext";

const STATUSES = [
  { id: "just_started", label: "Just started", icon: "🌱", color: "#9AE6B4" },
  { id: "still_working", label: "Still working on it", icon: "💪", color: "#FBD38D" },
  { id: "almost_there", label: "Almost there", icon: "🚀", color: "#90CDF4" },
  { id: "good_enough", label: "Good enough for me", icon: "👍", color: "#C4B5FD" },
  { id: "perfection", label: "Perfection", icon: "⭐", color: "#FFB703" },
];

export default function SongStatusToggle({ value, onChange, compact = false, testIdPrefix = "status" }) {
  const t = useT();
  return (
    <div className={`flex flex-wrap gap-1.5 ${compact ? "" : ""}`} data-testid={`${testIdPrefix}-toggle`}>
      {STATUSES.map((s) => {
        const active = value === s.id;
        const label = t(s.label);
        return (
          <button
            key={s.id}
            type="button"
            onClick={() => onChange(s.id)}
            data-testid={`${testIdPrefix}-${s.id}`}
            className={`px-2.5 py-1.5 rounded-full text-xs font-semibold border-2 transition-all ${active ? "" : "hover:-translate-y-0.5"}`}
            style={{
              borderColor: active ? "var(--app-accent)" : "var(--app-border)",
              background: active ? s.color : "var(--app-surface)",
              color: "var(--app-text)",
            }}
            title={label}
          >
            <span className="mr-1">{s.icon}</span>{label}
          </button>
        );
      })}
    </div>
  );
}

export { STATUSES };
